import Carousel from "@/components/ui/carousel/carousel";
import Section from "@/components/ui/section";
import Image from "next/image";
import React from "react";
import { SwiperSlide } from "swiper/react";
import { InstagramEmbed } from "react-social-media-embed";

export default function Banner({ insta }) {
  const breakpoints = {
    1280: {
      slidesPerView: 3.8,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    991: {
      slidesPerView: 2.8,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 1.8,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    320: {
      slidesPerView: 1.2,
      spaceBetween: 15,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
  };
  return (
    <>
      <Section className="bg-[#F6F5F1]">
        <div className="text-[#676665] text-left w-full flex flex-col justify-start items-start gap-1 mt-20">
          <h1 className="font-havletica font-light text-darkGrey">
           Explore Chalk Studio’s media features, design recognitions, and press highlights.
          </h1>
          <p className="text-sm font-grotesk font-light text-darkGrey lg:max-w-[443px]">
            We take pride in our research-based process, which helps us
            carefully evaluate every detail of a design before moving to
            execution. This approach has been key to delivering standout turnkey
            projects. By always questioning traditional methods, we’ve developed
            a knack for replacing outdated practices with fresh, innovative
            solutions. It’s this commitment to excellence and forward thinking that has earned us recognition and coverage in reputed magazines. Explore Chalk Studio’s media features, design recognitions, and press highlights.
          </p>
        </div>
      </Section>
      <div className="w-full mb-20">
        <Carousel
          slidesPerView={3.8}
          spaceBetween={20}
          loop={false}
          className="featureCarousel w-full my-8"
          breakpoints={breakpoints}
          navigation={true}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          }}
          freeMode={true}
          // pagination={false}
          showNavAbove={true}
          title=""
          // title="Our Values"
        >
          {insta?.map((post, key) => (
            <SwiperSlide key={"Insta" + key}>
              <InstaEmbed link={post?.link} />
            </SwiperSlide>
          ))}
        </Carousel>
      </div>
    </>
  );
}
const InstaEmbed = ({ link }) => {
  return (
    <div className="w-full h-auto">
      <InstagramEmbed url={link} />
    </div>
  );
};
const PostCard = ({ data }) => {
  const { title, logo, id, image } = data;
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="md:p-4 p-2 flex items-center">
        <Image
          src={"/images/icons/insta-chalk.svg"}
          alt="Logo"
          width={40}
          height={40}
          className="rounded-full"
        />
        <p className="ml-3 text-[13px] text-darkGrey">chalkstudio.design</p>
      </div>

      <div className="relative">
        <Image
          src={image}
          alt="Interior design"
          width={400} // Set the appropriate width for the image
          height={300} // Set the appropriate height for the image
          className="w-full object-cover"
          layout="responsive" // Ensures the image is responsive
        />
      </div>

      <div className="md:p-4 px-2 py-3 flex justify-between items-center">
        <div className="flex space-x-4">
          <Image src="/like-button.png" alt="Like" width={20} height={20} />
          <Image src="/comment-icon.png" alt="Comment" width={20} height={20} />
          <Image src="/share-icon.png" alt="Share" width={20} height={20} />
        </div>

        <Image src="/save-icon.png" alt="Save" width={24} height={24} />
      </div>
    </div>
  );
};
